import React, { useState } from "react";
import "../AddMedicalStore/addMedicalStore.css";

const AddHospital = () => {
  const [hospitalData, setHospitalData] = useState({
    name: "",
    hospitalSpecialization: "",
    address: "",
    phoneNumber: "",
    mapIframe: "",
    hospitalImage: null,
  });

  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setHospitalData({ ...hospitalData, [name]: value });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setHospitalData({ ...hospitalData, hospitalImage: file });
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Log the data to check values
    console.log("Form Data:", hospitalData);

    // Trim all string values
    const trimmedData = {
      name: hospitalData.name.trim(),
      hospitalSpecialization: hospitalData.hospitalSpecialization.trim(),
      address: hospitalData.address.trim(),
      phoneNumber: hospitalData.phoneNumber.trim(),
      mapIframe: hospitalData.mapIframe.trim(),
    };

    // Check if any required field is empty
    if (Object.values(trimmedData).some((value) => !value)) {
      setMessage({
        text: "All fields marked with * are required!",
        type: "error",
      });
      setIsLoading(false);
      return;
    }

    try {
      const formData = new FormData();

      // Append all trimmed data
      Object.keys(trimmedData).forEach((key) => {
        formData.append(key, trimmedData[key]);
      });

      // Append image if exists
      if (hospitalData.hospitalImage) {
        formData.append("image", hospitalData.hospitalImage);
      }

      const response = await fetch(
        "https://api.swasthmitra.com/api/hospital/createhospital",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();
      console.log("Response:", data); // Log response for debugging

      if (response.ok) {
        setMessage({ text: "Hospital added successfully!", type: "success" });
        // Reset form
        setHospitalData({
          name: "",
          hospitalSpecialization: "",
          address: "",
          phoneNumber: "",
          mapIframe: "",
          hospitalImage: null,
        });
        setImagePreview(null);
      } else {
        throw new Error(data.message || "Error adding hospital");
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage({
        text: error.message || "An error occurred. Please try again.",
        type: "error",
      });
    }

    setIsLoading(false);
  };

  return (
    <div className="form-container">
      <h2>Add Hospital</h2>

      {message && (
        <div className={`message ${message.type}`}>{message.text}</div>
      )}

      <form className="medical-store-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Hospital Name*</label>
          <input
            type="text"
            id="name"
            name="name"
            value={hospitalData.name}
            onChange={handleChange}
            placeholder="Enter hospital name"
          />
        </div>

        <div className="form-group">
          <label htmlFor="hospitalSpecialization">
            Hospital Specializations* (comma separated)
          </label>
          <input
            type="text"
            id="hospitalSpecialization"
            name="hospitalSpecialization"
            value={hospitalData.hospitalSpecialization}
            onChange={handleChange}
            placeholder="e.g., Cardiology, Orthopedics, Neurology"
          />
        </div>

        <div className="form-group">
          <label htmlFor="phoneNumber">Phone Number*</label>
          <input
            type="tel"
            id="phoneNumber"
            name="phoneNumber"
            value={hospitalData.phoneNumber}
            onChange={handleChange}
            placeholder="Enter hospital phone number"
          />
        </div>

        <div className="form-group">
          <label htmlFor="address">Address*</label>
          <textarea
            id="address"
            name="address"
            value={hospitalData.address}
            onChange={handleChange}
            placeholder="Enter hospital address"
          />
        </div>

        <div className="form-group">
          <label htmlFor="mapIframe">Google Maps Embed Code</label>
          <textarea
            id="mapIframe"
            name="mapIframe"
            value={hospitalData.mapIframe}
            onChange={handleChange}
            placeholder="Paste Google Maps iframe code here"
            rows="4"
          />
          <small className="help-text">
            To get the embed code: 1. Go to Google Maps 2. Find your location 3.
            Click "Share" 4. Select "Embed a map" 5. Copy the iframe code
          </small>
          {hospitalData.mapIframe && (
            <div className="map-preview">
              <div
                dangerouslySetInnerHTML={{ __html: hospitalData.mapIframe }}
              />
            </div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="hospitalImage">Hospital Image</label>
          <input
            type="file"
            id="hospitalImage"
            name="hospitalImage"
            onChange={handleImageChange}
            accept="image/*"
          />
          {imagePreview && (
            <div className="image-preview">
              <img src={imagePreview} alt="Hospital preview" />
            </div>
          )}
        </div>

        <button type="submit" disabled={isLoading}>
          {isLoading ? "Adding Hospital..." : "Add Hospital"}
        </button>
      </form>
    </div>
  );
};

export default AddHospital;
